import { useTranslation } from "@coworker/locales";
import { useCustomAllSelectOption } from "@coworker/apprestructured/src/shared/filters/utils/useAllSelectOption";
import {
  FilterType,
  InputType,
} from "@coworker/apprestructured/src/shared/filters/types/filter";
import hfbNumbers from "../../InputPopup/UserFiltersRow/hfbNumbers.json";
import { formatHfbTitle } from "../Helpers/hfbHelpers";

const ARTICLE_HFB_ID = "articleHfb";

export function useArticleHfbFilter() {
  const { t } = useTranslation();
  const defaultValue = { filterId: ARTICLE_HFB_ID, value: "" };

  return useCustomAllSelectOption(
    {
      inputType: InputType.Select,
      filterType: FilterType.Filter,
      id: ARTICLE_HFB_ID,
      title: t("articleHFBString"),
      options: hfbNumbers.map((hfbNumber) => {
        return {
          value: hfbNumber,
          title: formatHfbTitle(hfbNumber, t),
        };
      }),
      enabled: true,
      defaultValue,
    },
    t("allHFBsString")
  );
}
